export var Variant;
(function (Variant) {
    Variant["READONLY"] = "readonly";
    Variant["DISABLED"] = "disabled";
    Variant["ERROR"] = "error";
})(Variant || (Variant = {}));
export var DatePickerVariant;
(function (DatePickerVariant) {
    DatePickerVariant["DEFAULT"] = "default";
    DatePickerVariant["RANGE_PICKER"] = "rangePicker";
    DatePickerVariant["RANGE_PICKER_RIGHT"] = "rangePickerRight";
    DatePickerVariant["READONLY"] = "readonly";
    DatePickerVariant["DISABLED"] = "disabled";
    DatePickerVariant["ERROR"] = "error";
})(DatePickerVariant || (DatePickerVariant = {}));
//# sourceMappingURL=DatePicker.types.js.map